import { WSCard } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useLearnMoreRequirementTemplateModal } from "../../../../modals/LearnMoreRequirementTemplateModal";
import { buildRequirementDetailsPath } from "../../../../paths/helpers";
import { RequirementDefinitionTemplate, TemplateTierConfig } from "../../types";
import { TemplateImage } from "../TemplateImage";
import styles from "./index.module.scss";

type Props = {
  itemConfig: RequirementDefinitionTemplate;
  tierConfig: TemplateTierConfig;
  onSelect: (item: RequirementDefinitionTemplate) => void;
  selected: RequirementDefinitionTemplate | null;
  existingRequirementId?: string;
};

export const Item: React.FC<Props> = props => {
  const history = useHistory();

  const isDisabled = !!props.existingRequirementId;

  const learnMoreRequirementTemplateModal =
    useLearnMoreRequirementTemplateModal();

  const isWayfinder = props.tierConfig.isWayfinder;

  return (
    <WSCard
      className={isDisabled ? styles.disabled : undefined}
      onClick={isDisabled ? undefined : () => props.onSelect(props.itemConfig)}
      active={isDisabled ? false : props.selected?.key === props.itemConfig.key}
      header={{
        label: {
          avatar: {
            icon: props.itemConfig.icon,
            type: "icon"
          },
          text: props.itemConfig.name,
          helperText: [
            props.itemConfig.helperText,
            props.itemConfig.isBillable ? "(Billable)" : undefined
          ]
            .filter(Boolean)
            .join("\n")
        },
        value: {
          pill: !isWayfinder
            ? {
                text: "Standard",
                theme: "neutral"
              }
            : undefined,
          icon: isWayfinder
            ? {
                name: "compass",
                color: "garnet"
              }
            : undefined
        }
      }}
      actions={{
        alignment: "left",
        buttons: props.existingRequirementId
          ? [
              {
                label: "View requirement",
                rightIcon: "open-tab",
                kind: "Link",
                onClick: () => {
                  history.push(
                    buildRequirementDetailsPath(props.existingRequirementId!)
                  );
                }
              }
            ]
          : [
              {
                label: "Learn more",
                rightIcon: "open-tab",
                kind: "Link",
                onClick: () => {
                  learnMoreRequirementTemplateModal.open({
                    template: props.itemConfig
                  });
                }
              }
            ]
      }}
    >
      <TemplateImage {...props.itemConfig} disabled={isDisabled} />
    </WSCard>
  );
};
